import { ButtonViewComponent } from './../../shared';
import { CustomEditorComponent } from './../../shared';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { dataTable } from './shared/data.service';

@Component({
  selector: 'iw-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DataTableComponent implements OnInit {
  // variable donde se configura las opciones de la tabla
  // documentacion: https://akveo.github.io/ng2-smart-table/#/documentation
  settings = {
    mode: 'external',
    noDataMessage: 'No hay resultados',
    actions: {
      columnTitle: 'Acciones',
      position: 'right'
    },
    add: {
      inputClass: 'form-control',
      addButtonContent: 'Agregar',
      createButtonContent: 'Agregar',
      cancelButtonContent: 'Cancelar'
    },
    edit: {
      inputClass: 'form-control',
      editButtonContent: 'Actualizar',
      saveButtonContent: 'Actualizar',
      cancelButtonContent: 'Cancelar'
    },
    delete: {
      inputClass: 'form-control',
      deleteButtonContent: 'Eliminar',
    },
    attr: {
      class: 'table-bordered table-hover'
    },
    columns: {
      id: {
        editable: false,
        addable: false,
        title: 'ID',
        class: 'prueba',
        filter: {
          inputClass: 'form-control',
        },
      },
      name: {
        title: 'Full Name',
        filter: {
          inputClass: 'form-control',
          type: 'list',
          config: {
            selectText: 'Select...',
            list: [
              { value: 'Glenna Reichert', title: 'Glenna Reichert' },
              { value: 'Kurtis Weissnat', title: 'Kurtis Weissnat' },
              { value: 'Chelsey Dietrich', title: 'Chelsey Dietrich' },
            ],
          },
        },
      },
      email: {
        title: 'Email',
        filter: {
          inputClass: 'form-control',
          type: 'completer',
          config: {
            completer: {
              data: dataTable,
              searchFields: 'email',
              titleField: 'email',
            },
          },
        },
      },
      passed: {
        title: 'Passed',
        filter: {
          inputClass: 'form-control',
          type: 'checkbox',
          config: {
            true: 'Sí',
            false: 'No',
            resetText: 'Todo',
          },
        },
      },
      file: {
        title: 'Referencias',
        filter: false,
        type: 'html',
        editor: {
          type: 'custom',
          component: CustomEditorComponent,
        },
      },
      button: {
        title: 'Button',
        filter: false,
        type: 'custom',
        renderComponent: ButtonViewComponent,
        onComponentInitFunction(instance: any) {
          instance.save.subscribe((row: any) => {
            // controla el evento click del boton
            alert(`${row.name} saved!`);
          });
        }
      },
    },
  };
  // se utiliza para setear los datos en formato de la libreria de la tabla
  // para poder realizar el filtro general
  source: LocalDataSource;

  constructor() {
    this.source = new LocalDataSource(dataTable);
  }

  ngOnInit() {
  }
  /**
   * controla el filtro general de la tabla
   * Nota: para utilizar esta funcion y el filtro general tener encuenta
   *       que los ftltros por culumna deben estar desactivados
   *
   * @param {string} [query='']
   * @memberof DataTableComponent
   */
  onSearch(query: string = '') {
    // campos que queremos incluir en la búsqueda
    this.source.setFilter([
      {
        field: 'id',
        search: query
      },
      {
        field: 'name',
        search: query
      },
      {
        field: 'username',
        search: query
      },
      {
        field: 'email',
        search: query
      }
    ], false);
    // segundo parámetro que especifica si se debe realizar una búsqueda 'AND' o 'OR'
    // (lo que significa que todas las columnas deben contener una consulta de búsqueda o al menos una)
    // 'AND' de forma predeterminada, por lo que cambia a 'OR' al establecer false aquí
  }
  /**
   * controla el evento al seleccionar una fila
   *
   * @param {*} data
   * @returns {*}
   * @memberof DataTableComponent
   */
  rowSelect(data: any): any {
    console.log(data);
  }
  /**
   * Controla el evento al dar click en una de las acciones de la tabla
   * agregar, actualizar, modificar
   * Nota: este evento solo se ejecutara si la propieda "mode" de la configuracion de la tabla es external
   *
   * @param {*} data
   * @returns {*}
   * @memberof DataTableComponent
   */
  accion(data: any): any {
    console.log(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/data-table/data-table.component.ts